import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { authReset, logout, setSessionExpired } from 'redux/auth';
import { membershipReset } from 'redux/membership';
import { detailsReset } from 'redux/details';
import { estimateReset } from 'redux/estimate';
import { paymentReset } from 'redux/payment';
import { portalReset } from 'redux/portal';

const AutoLogout = ({ children }) => {
  let logoutTimer;
  const startTimer = () => {
    clearTimeout(logoutTimer); // Clear any existing timer
    logoutTimer = setTimeout(() => {
      handleLogout();
    }, 300000); // 5 minutes
  };

  const resetTimer = () => {
    startTimer(); // Restart the timer on user activity
  };
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout()).then(() => {
      dispatch(membershipReset());
      dispatch(detailsReset());
      dispatch(estimateReset());
      dispatch(paymentReset());
      dispatch(portalReset());
      dispatch(authReset());
      dispatch(setSessionExpired(true));
    });
  };

  useEffect(() => {
    window.addEventListener('mousemove', resetTimer);
    window.addEventListener('keypress', resetTimer);

    // Start the timer initially
    startTimer();

    return () => {
      window.removeEventListener('mousemove', resetTimer);
      window.removeEventListener('keypress', resetTimer);
      clearTimeout(logoutTimer);
    };
  }, []);

  return <>{children}</>;
};

AutoLogout.propTypes = {
  children: PropTypes.node.isRequired
};

export default AutoLogout;
